export enum EZeroValueSelectionOptionDisplayMode {
  ShowFree = 0,
  ShowNothing = 1,
  ShowBasePrice = 2,
}
